import React from 'react';

import { useStylesModalOffer } from './hooks/useStyles';
import { IProduct } from '../../../../../interfaces/product';
import { HeaderOfferForBuyer } from './HeaderOfferForBuyer';
import { OffersForBuyerTable } from './OffersForBuyerTable';
import { OffersForBuyerGrid } from './OffersForBuyerGrid';
import { useSortedOffers } from './hooks/useSortedOffers';

export function OffersForBuyer({
  product,
  showMoreItems,
}: {
  product: IProduct;
  showMoreItems?: boolean;
}) {
  const { classes } = useStylesModalOffer();
  const [sort, setSort] = React.useState({
    label: 'По самой низкой цене за 1 шт.',
    value: 'priceUp',
  });
  const isMobile = window.innerWidth < 600;
  const [viewType, setViewType] = React.useState<'grid' | 'table'>(isMobile ? 'grid' : 'table');
  const [currentPage, setCurrentPage] = React.useState(0);
  // eslint-disable-next-line no-nested-ternary
  const perPage = viewType === 'grid' ? (showMoreItems ? 6 : 3) : showMoreItems ? 4 : 2;
  const startIndex = currentPage * perPage;
  const endIndex = startIndex + perPage;

  const sortedPrices = useSortedOffers({ prices: product.prices_values, sort: sort.value });

  const prices = sortedPrices.slice(startIndex, endIndex);

  if (prices.length === 0) return null;

  return (
    <>
      <div className={classes.offer}>
        <HeaderOfferForBuyer
          viewType={viewType}
          product={product}
          setSort={setSort}
          sort={sort}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setViewType={setViewType}
          perPage={perPage}
        />
        {viewType === 'table' && <OffersForBuyerTable prices={prices} product={product} />}
        {viewType === 'grid' && <OffersForBuyerGrid prices={prices} product={product} />}
      </div>
    </>
  );
}
